{
    "CookiesDescription": "Usamos cookies para melhorar sua experiência no Akixi. Para ver mais informações sobre como e por que usamos cookies, consulte nossa {}Política de cookies{}.",
    "CookieConsentChangeMessage": "Se você deseja alterar essa configuração, pode fazê-lo abaixo.",
    "AcceptedAllCookiesMessage": "Você aceitou todos os cookies.\n {}",
    "AcceptedFunctionalCookiesMessage": "Você aceitou apenas cookies de funcionalidade.\n {}",
    "RejectedAllCookiesMessage": "Você rejeitou todos os cookies. Isso significa que algumas funcionalidades do aplicativo não funcionarão.\n {}",
    "AcceptAllCookies": "Aceitar tudo",
    "AcceptFunctionalityCookies": "Aceitar cookies de funcionalidade",
    "RevokeAllCookies": "Revogar todo o consentimento",
    "RevokeStatisticsCookies": "Revogar consentimento de estatísticas",
    "RejectAllCookies": "Rejeitar tudo",
    "RejectionWarning": "Rejeitar todos os cookies significará que você não poderá usar todos os recursos do aplicativo. \n\n Se você precisar usar esses recursos no futuro, precisará \"Aceitar cookies de funcionalidade\" na página de Política de cookies.",
    "NAME": "CookieConsent"
}